module.exports = __webpack_public_path__ + "img/sun.592207be.png";